export const classes = {
  icon: {
    position: 'relative',
    top: '8px',
    left: '6px',
  },
}
